import { render, staticRenderFns } from "./profileAdmin.vue?vue&type=template&id=cdeb1e2e&scoped=true"
import script from "./profileAdmin.vue?vue&type=script&lang=js"
export * from "./profileAdmin.vue?vue&type=script&lang=js"
import style0 from "./profileAdmin.vue?vue&type=style&index=0&id=cdeb1e2e&prod&lang=scss"
import style1 from "./profileAdmin.vue?vue&type=style&index=1&id=cdeb1e2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdeb1e2e",
  null
  
)

export default component.exports